// extracted by mini-css-extract-plugin
export default {"addToCartControl":"i2-z","giftCard":"j2-z","btnContainer":"k2-z","cartButton":"l2-z","disabled":"m2-z"};